export default {
  'EditActMembers.inviteTitle': {
    en: 'Invite artists to your act',
    fr: 'Invitez les artistes à votre acte',
  },
};
